import React, { useState, useEffect, useCallback } from "react";
import {
  guestSignIn,
  getUserLevel,
  getToken,
  getUser,
} from "auth/authenticate";

const UserContext = React.createContext({});

export const UserProvider = ({ children, settings = null }) => {
  const [user, setUser] = useState(getUser());
  const [userRole, setUserRole] = useState(getUserLevel());
  const [loading, setLoading] = useState(false);

  const defaultSettings = {
    user_id: 1,
    user_type: 1,
  };
  const [currentSettings, setCurrentSettings] = useState(
    settings || defaultSettings
  );
  const saveSettings = (values) => {
    setCurrentSettings(values);
  };

  //  const refreshUser = useCallback(() => {
  //   const token = getToken();
  //   if (token) {
  //     const userData = getUser();
  //     const role = getUserLevel();
      
  //     setUser(userData);
  //     setUserRole(role);
      
  //     console.log('User context refreshed:', userData); // For debugging
  //   } else {
  //     // No token means guest
  //     setUser(null);
  //     setUserRole('GUEST');
  //   }
  // }, []);


  useEffect(() => {
    if (userRole === "GUEST") {
      guestSignIn();
    }
  }, [userRole]);

  // useEffect(() => {
  //     const checkAuth = async () => {
  //       setLoading(true);
  //       const token = getToken();
  //       const role = getUserLevel();
  //       // Only sign in as guest if NO token or role is missing/invalid
  //       if (!token || role === "GUEST") {
  //         await guestSignIn();
  //         setUser(getUser());
  //         setUserRole(getUserLevel());
  //       } else {
  //         setUser(getUser());
  //         setUserRole(role);
  //       }
  //       setLoading(false);
  //     };
  //     checkAuth();
  //   }, []);

  // watch for token changes (e.g., on mount and when the token changes).
  // Update userRole and user when the token changes.

  // useEffect(() => {
  //   const checkAuth = async () => {
  //     setLoading(true);
  //     const token = getToken();
  //     const role = getUserLevel();
  //     if (!token || role === "GUEST") {
  //       await guestSignIn();
  //       setUser(getUser());
  //       setUserRole(getUserLevel());
  //     }
  //     setUser(getUser());
  //     setUserRole(getUserLevel());
  //     setLoading(false);
  //   };
  //   checkAuth();
  //   // Optionally, listen for token changes in localStorage for multi-tab support
  //   // window.addEventListener("storage", checkAuth);
  //   // return () => window.removeEventListener("storage", checkAuth);

  // },[]);




  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        userRole,
        setUserRole,
        settings: currentSettings,
        saveSettings,
        // refreshUser,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
